var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.latestBidsModal",modifiers:{"latestBidsModal":true}}],staticClass:"ta-show-all-bids-link",attrs:{"href":"javascript:void(0)"}},[_vm._v(" "+_vm._s(_vm.$t('View All Bids'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }